import React from 'react'
import { TableCell } from '@atd/rui-base.mui.table-cell'

// Use this class to prevent default actions on a specific table column
// Ex. you want to put a button or dropdown in a column, and don't want
// clicking that component to also call row selection.
class TableRowColumnWrapper extends React.Component {

    render() {
        return (
            <TableCell className={this.props.className} style={this.props.style} onClick={(e) => { e.stopPropagation(); if (this.props.onCellClick) this.props.onCellClick(e) }}>
                {this.props.children}
            </TableCell>
        )
    }
}

export default TableRowColumnWrapper
